/**
 * coupon相关功能
 * 1. 用户使用code, 调用graphql使用code, 返回是否使用成功
 *  a. 使用成功输入框显示折扣码tag, 支持点击删除,
 *  b. 使用失败提示Enter a valid discount code or gift card
 * 2. 打开迷你购物车或者进入购物车页调用/cart.js查看当前购物车字段cart_level_discount_applications有无使用code
 *  a. 使用了显示折扣码tag, 支持点击删除,
 *  b. 没有使用保存初始状态
 *
 * */
class CouponPlugin {
  constructor() {
    this.use_error_msg = 'Saisissez un code de réduction ou une carte-cadeau valide';
    this.emtry_error_msg = 'Saisissez un code de réduction ou une carte-cadeau';
    this.initEvent()
  }
  // 注册事件
  initEvent() {
    // 使用事件委托注册点击事件
    document.addEventListener('click', (event) => {
      // 应用优惠码按钮
      if (event.target.id === 'apply-discount-btn' || event.target.closest('#apply-discount-btn')) {
        this.handleApplyDiscount(event);
      }

      // 移除优惠码按钮
      if (event.target.classList.contains('remove-discount-btn') || event.target.closest('.remove-discount-btn')) {
        this.handleRemoveDiscount(event);
      }
    });

    // 监听回车键
    document.addEventListener('keypress', (event) => {
      if (event.key === 'Enter' && document.activeElement.id === 'discount-code-input') {
        this.handleApplyDiscount(event);
      }
    });
  }

  // 处理应用优惠码
  async handleApplyDiscount(event) {
    event.preventDefault(); // 阻止默认行为

    const discountInput = document.getElementById('discount-code-input');
    if (!discountInput) return;

    const code = discountInput.value.trim();
    if (!code) {
      this.showMessage(this.emtry_error_msg, 'error');
      return;
    }

    const applyBtn = document.getElementById('apply-discount-btn');
    if (applyBtn) {
      // 显示加载状态
      applyBtn.disabled = true;
      applyBtn.classList.add('loading');
    }

    try {
      const result = await this.updateCartDiscountCodes(code);

      if (applyBtn) {
        // 恢复按钮状态
        applyBtn.disabled = false;
        applyBtn.classList.remove('loading');
      }

      if (result.success) {
        discountInput.value = '';
        this.showMessage('', 'success');
        // 触发购物车更新事件
        document.dispatchEvent(
          new CustomEvent('on:cart:change', {
            bubbles: true,
            cancelable: false
          })
        );
      } else {
        // 触发购物车更新事件，而不是刷新页面
        document.dispatchEvent(
          new CustomEvent('on:cart:change', {
            bubbles: true,
            cancelable: false
          })
        );
        setTimeout(() => {
          this.showMessage(result.message || this.use_error_msg, 'error');
        }, 800)
      }
    } catch (error) {
      if (applyBtn) {
        // 恢复按钮状态
        applyBtn.disabled = false;
        applyBtn.classList.remove('loading');
      }

      this.showMessage(this.use_error_msg, 'error');
      console.error(error);
    }
  }

  // 处理移除优惠码
  async handleRemoveDiscount(event) {
    event.preventDefault(); // 阻止默认行为

    const btn = event.target.closest('.remove-discount-btn');
    if (!btn) return;

    try {
      // 显示加载状态
      btn.disabled = true;
      btn.classList.add('loading');

      // 移除优惠码
      const result = await this.updateCartDiscountCodes('');

      // 恢复按钮状态
      btn.disabled = false;

      if (result.success) {
        this.showMessage('', 'success');

        // 触发购物车更新事件，而不是刷新页面
        document.dispatchEvent(
          new CustomEvent('on:cart:change', {
            bubbles: true,
            cancelable: false
          })
        );
      } else {
        this.showMessage('', 'error');
      }
    } catch (error) {
      // 恢复按钮状态
      if (btn) {
        btn.disabled = false;
        btn.classList.remove('loading');
      }

      console.error(error);
    }
  }

  // 显示消息
  showMessage(message, type) {
    const discountMessage = document.getElementById('discount-message');
    if (!discountMessage) return;

    discountMessage.textContent = message;
    discountMessage.className = 'discount-message';
    if (type) {
      discountMessage.classList.add(type);
    }

  }

  async updateCartDiscountCodes(code) {
    try {
      if (!code) {
        // 如果是移除优惠码，使用正确的端点移除优惠码
        try {
          // 尝试使用/discount/clear端点移除优惠码
          const clearResponse = await fetch('/discount/clear', {
            method: 'GET'
          });

          // 获取最新的购物车数据
          const cartResponse = await fetch('/cart.js');
          const updatedCart = await cartResponse.json();

          return {
            success: true,
            cart: updatedCart,
            message: '优惠码已移除'
          };
        } catch (clearError) {
          console.error('移除优惠码失败:', clearError);

          // 如果/discount/clear端点失败，尝试使用/cart/update.js端点
          const response = await fetch('/cart/update.js', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
            },
            body: JSON.stringify({
              discount_code: '',
              note: null
            }),
          });

          const updatedCart = await response.json();

          return {
            success: true,
            cart: updatedCart,
            message: '优惠码已移除'
          };
        }
      } else {
        // 如果是应用优惠码，使用标准AJAX API应用优惠码
        // 首先尝试使用/discount/{code}端点
        try {
          const applyResponse = await fetch(`/discount/${code}`, {
            method: 'GET'
          });

          // 获取最新的购物车数据
          const cartResponse = await fetch('/cart.js');
          const updatedCart = await cartResponse.json();

          // 检查购物车中是否有折扣
          const hasDiscount = (updatedCart.cart_level_discount_applications &&
            updatedCart.cart_level_discount_applications.length > 0)
            || updatedCart.total_discount > 0;

          if (hasDiscount) {
            return {
              success: true,
              cart: updatedCart,
              message: '优惠码应用成功'
            };
          } else {
            return {
              success: false,
              cart: updatedCart,
              message: this.use_error_msg
            };
          }
        } catch (discountError) {
          console.error('应用折扣码失败:', discountError);

          // 如果/discount/{code}端点失败，尝试使用/cart/update.js端点
          try {
            const updateResponse = await fetch('/cart/update.js', {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json',
              },
              body: JSON.stringify({
                discount_code: code,
                note: null
              }),
            });

            const updatedCart = await updateResponse.json();

            // 检查购物车中是否有折扣
            const hasDiscount = updatedCart.cart_level_discount_applications &&
                               updatedCart.cart_level_discount_applications.length > 0;

            if (hasDiscount) {
              return {
                success: true,
                cart: updatedCart,
                message: '优惠码应用成功'
              };
            } else {
              return {
                success: false,
                cart: updatedCart,
                message: this.use_error_msg
              };
            }
          } catch (updateError) {
            console.error('更新购物车失败:', updateError);
            return {
              success: false,
              error: updateError.message,
              message: this.use_error_msg
            };
          }
        }
      }
    } catch (error) {
      console.error('请求失败:', error);
      return { success: false, error: error.message };
    }
  }

  // 获取购物车数据
  async getCartData() {
    try {
      const response = await fetch('/cart.js');
      return await response.json();
    } catch (error) {
      console.error('Failed to fetch cart data:', error);
      throw error;
    }
  }
}

window._couponPlugin = new CouponPlugin();
